import { render, staticRenderFns } from "./ListaAssistentes.vue?vue&type=template&id=bec1e236&scoped=true"
import script from "./ListaAssistentes.vue?vue&type=script&lang=js"
export * from "./ListaAssistentes.vue?vue&type=script&lang=js"
import style0 from "./ListaAssistentes.vue?vue&type=style&index=0&id=bec1e236&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec1e236",
  null
  
)

export default component.exports